import axios from 'axios'
import {getSessionId} from './sessionManager'

const BASE = `${process.env.REACT_APP_API_ENDPOINT}external/ct/controltower/v1/wms/usage-analytics`

// Fire-and-forget: errors are swallowed so tracking never affects the user
const fire = (path, payload) => {
  axios.post(`${BASE}${path}`, payload).catch(() => {})
}

export const trackExport = (p) => fire('/events/export', p)
export const trackError = (p) => fire('/events/error', p)
export const trackSearch = (p) => fire('/events/search', p)
export const trackFeature = (p) => fire('/events/feature', p)
export const trackNav = (p) => fire('/heartbeat', {...p, type: 'NAVIGATION', event: 'NAVIGATION'})
export const trackHeartbeat = (p) => fire('/heartbeat', {...p, type: 'HEARTBEAT', event: 'PAGE_VIEW'})

export {getSessionId}
